<template>
  <chart-item title="绿毒通风状态信息" class="wind-info">
    <ul>
      <li>
        <span>开关状态:</span>
        <span>{{ windState ? '打开' : '关闭' }}</span>
        <el-switch
          v-if="authMenu['01040506']"
          style="margin: 0 5px"
          v-model="windState"
          active-color="#00FF96"
          :active-value="1"
          :inactive-value="0"
          @change="changeWindState"
        ></el-switch>
        <span v-show="isPast" class="warning-box animated flash slow infinite">建议更换滤芯</span>
      </li>
      <li>
        <span>设备安装时间:</span>
        <span>{{ formatTime(windInfo.installTime) }}</span>
      </li>
      <li>
        <span>累计报警时间:</span>
        <span>{{ allWarnTime }}</span>
      </li>
      <li>
        <span>累计工作时间:</span>
        <span>{{ allWorkTime }}</span>
      </li>
      <li>
        <span>建议更换时间:</span>
        <span>{{ formatTime(windInfo.replaceTime) }}</span>
      </li>
    </ul>
    <el-button
      type="text"
      @click="queryInfo"
      style="position: absolute; top: 0px; right: 10px"
      size="medium"
    >
      刷新
    </el-button>
  </chart-item>
</template>

<script>
import { mapState } from 'vuex';

import { formatTime, throughTime } from '@/utils/utils';
import ctt from '@/utils/const';
import { periphState, periphInfo } from '@/api/peripherals';
import ChartItem from '@/components/chart-item';

export default {
  components: { ChartItem },
  props: {
    sn: String
  },
  data() {
    return {
      windState: ctt.PPB_OFF,
      windInfo: {
        installTime: '', // 设备安装时间
        alarmPercent: 0, // 污染率
        replaceTime: '', // 建议更换时间
        alarmTime: 0, // 污染时间(报警时间)
        normalTime: 0 // 非污染时间
      },
      isPast: false, // 是否更换滤芯
      warnCount: 0, // 页面开启后采集的报警计时
      farmalCount: 0 // 页面开启后的计时
    };
  },
  computed: {
    ...mapState('socket', ['singleDeviceDetail']),
    allWorkTime() {
      // 累计工作时长 年天时分秒
      const alltime =
        parseInt(this.windInfo.alarmTime) + parseInt(this.windInfo.normalTime) + this.farmalCount;
      return throughTime(alltime);
    },
    allWarnTime() {
      return throughTime(parseInt(this.windInfo.alarmTime) + this.warnCount);
    }
  },
  methods: {
    formatTime,
    throughTime,
    queryInfo() {
      this.timer2 && clearInterval(this.timer2);
      periphState(this.sn, ctt.PPB_SEARCH, ctt.PPT_LV).then(res => {
        this.windState = res.data.state;
        this.timer2 = setInterval(() => {
          this.farmalCount++;
        }, 1000);
      });
      periphInfo(this.sn, ctt.PPT_LV).then(res => {
        this.windInfo = Object.assign(this.windInfo, res.data);
      });
    },
    changeWindState(val) {
      periphState(this.sn, val, ctt.PPT_LV)
        .then(res => {
          if (res.code !== 200) {
            this.windState = val ? ctt.PPB_OFF : ctt.PPB_ON;
          } else {
            this.$message({
              type: 'info',
              message: '开启中'
            });
          }
        })
        .catch(() => {
          this.windState = val ? ctt.PPB_OFF : ctt.PPB_ON;
        });
    },
    updateWindState(state) {
      this.windState = state;
    },
    pad0(d) {
      return d < 10 ? '0' + d : d;
    },
    pastTest(time) {
      const nowTime = new Date();
      const repTime = new Date(time);
      if (nowTime > repTime || nowTime === repTime) {
        this.isPast = true;
      }
    }
  },
  watch: {
    windState(newVal) {
      if (newVal) {
        this.timer1 = setInterval(() => {
          this.warnCount++;
        }, 1000);
      } else {
        this.timer1 && clearInterval(this.timer1);
      }
    },
    farmalCount() {
      this.pastTest(this.windInfo.replaceTime);
    }
  },
  created() {
    this.queryInfo();
  },
  beforeDestroy() {
    this.timer1 && clearInterval(this.timer1);
    this.timer2 && clearInterval(this.timer2);
  }
};
</script>

<style lang="scss">
.wind-info.chart-item {
  margin-bottom: 8px;
  position: relative;
  &:last-child {
    margin-bottom: 0;
  }
  ul {
    height: 100%;
    color: $normal-color;
    font-size: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    text-indent: 20px;
    li {
      line-height: 28px;
    }
  }
  .warning-box {
    color: $danger-color;
  }
}
</style>
